import { render, staticRenderFns } from "./SellerRegistrationApply.vue?vue&type=template&id=4a7bf4b3&scoped=true"
import script from "./SellerRegistrationApply.vue?vue&type=script&lang=js"
export * from "./SellerRegistrationApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7bf4b3",
  null
  
)

export default component.exports